import { render, staticRenderFns } from "./maritalStatus.vue?vue&type=template&id=088633aa&scoped=true"
import script from "./maritalStatus.vue?vue&type=script&lang=js"
export * from "./maritalStatus.vue?vue&type=script&lang=js"
import style0 from "./maritalStatus.vue?vue&type=style&index=0&id=088633aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088633aa",
  null
  
)

export default component.exports